import React from 'react'
import {FaLinkedin, FaGithub} from 'react-icons/fa'
import {IoLogoTwitter} from 'react-icons/io'
import './footer.css';

const Footer = () => {
    return (
        <footer>
{/*             <a href="#" className='footer__logo'>Deepak Kumar</a> */}
            <a href="#home" className='footer__logo'>Deepak Kumar</a>

            <ul className='permalinks'>
{/*                 <li><a href="#">Home</a></li> */}
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Experience</a></li>
                <li><a href="#portfolio">Portfolio</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>

            <div className="footer__socials">
                <a href="https://www.linkedin.com/in/deepak-kumar-0b11b7210/"><FaLinkedin /></a>
                <a href="https://github.com/deepak2002139"><FaGithub/></a>
                <a href="https://twitter.com/dk2002139"><IoLogoTwitter/></a>
            </div>

            <div className="footer__copyright">
                <small>&copy; Deepak. All rights reserved</small>
            </div>

        </footer>
    )
}

export default Footer
